// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HyJH","colBig":"styles_colBig__2VF00","colSmall":"styles_colSmall__i9xQI"};